'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  width: 100%;\n  height: 100%;\n\n  font-family: ', ';\n  font-size: ', 'px;\n  color: ', ';\n\n  ', ';\n'], ['\n  width: 100%;\n  height: 100%;\n\n  font-family: ', ';\n  font-size: ', 'px;\n  color: ', ';\n\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _background = require('./background');

var _layouts = require('./layouts');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Slide = function (_Component) {
  _inherits(Slide, _Component);

  function Slide() {
    _classCallCheck(this, Slide);

    return _possibleConstructorReturn(this, (Slide.__proto__ || Object.getPrototypeOf(Slide)).apply(this, arguments));
  }

  _createClass(Slide, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var bgChanged = this.props.onBackgroundChange;

      var backgroundEl = (0, _background.backgroundFor)(this.props);
      bgChanged && bgChanged(backgroundEl);
    }
  }, {
    key: 'getLayoutComponent',
    value: function getLayoutComponent(handle) {
      switch (handle) {
        case 'default':
          return _layouts.DefaultLayout;
        case 'centered':
          return _layouts.CenteredLayout;
      }

      // use no layout
      return null;
    }
  }, {
    key: 'renderWithinLayout',
    value: function renderWithinLayout(children) {
      var layout = this.props.layout;
      var centered = this.props.centered;

      // Custom layout rendering function

      if (typeof layout === 'function') {
        return layout(children);
      }

      if (centered) layout = 'centered';
      var Layout = this.getLayoutComponent(layout);

      if (Layout) {
        return _react2.default.createElement(
          Layout,
          null,
          children
        );
      } else {
        return children;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          centered = _props.centered;


      return _react2.default.createElement(
        SlideContent,
        { className: className, centered: centered },
        this.renderWithinLayout(this.props.children)
      );
    }
  }]);

  return Slide;
}(_react.Component);

Slide.propTypes = {
  onBackgroundChange: _propTypes2.default.func,
  centered: _propTypes2.default.bool,

  // Layout determines how content is
  // positioned on a slide
  layout: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool, _propTypes2.default.func])
};
Slide.defaultProps = {
  centered: false,
  layout: 'default'
};


var SlideContent = _styledComponents2.default.div(_templateObject, function (props) {
  return props.theme.slide.baseFont;
}, function (props) {
  return props.theme.slide.baseFontSize;
}, function (props) {
  return props.theme.slide.textColor;
}, function (props) {
  return props.centered && '\n    display: flex;\n    flex-flow: column nowrap;\n    align-items: center;\n    justify-content: center;\n  ';
});

exports.default = Slide;